import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import authService from '@/services/auth';
import Cookies from 'js-cookie';

const adminRoutes = [].map((item) => {
  item.path = '/admin' + item.path;
  item.beforeEnter = (to, from, next) => {
    if (!useAuthStore().user?.isAdmin) next('/');
    next();
  };
  return item;
});

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/sem-acesso',
      name: 'SemAcesso',
      component: () => import('../views/PermissaoAcesso.vue'),
    },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
    },
    {
      path: '/consultar-cpf',
      name: 'consultar-cpf',
      component: () => import('../views/BuscaCPFView.vue'),
      beforeEnter: async (to, from, next) => {
        const permissao = await authService.getPermissao();
        if (permissao.retornoModulo === 1) {
          next();
        } else {
          next('/sem-acesso');
        }
      },
    },
    {
      path: '/buscar-registro',
      name: '/buscar-registro',
      component: () => import('../views/BuscaRegistroView.vue'),
      beforeEnter: async (to, from, next) => {
        const permissao = await authService.getPermissao();
        if (permissao.retornoModulo === 1) {
          next();
        } else {
          next('/sem-acesso');
        }
      },
    },
    {
      path: '/detalhe-registro/:tipo_registro/:id',
      name: 'DetalheRegistro',
      component: () => import('../views/DetalheRegistroView.vue'),
      beforeEnter: async (to, from, next) => {
        const permissao = await authService.getPermissao();
        if (permissao.retornoModulo === 1) {
          next();
        } else {
          next('/sem-acesso');
        }
      },
      props: {
        default: true,
      },
    },
    {
      path: '/pedido-certidao',
      name: 'pedido-certidao',
      component: () => import('../views/PedidoCertidao.vue'),
      beforeEnter: async (to, from, next) => {
        const permissao = await authService.getPermissao();
        if (permissao.retornoModulo === 1) {
          next();
        } else {
          next('/sem-acesso');
        }
      },
      props: {
        default: true,
      },
    },
    {
      path: '/nivel-baixo',
      name: 'nivel-baixo',
      component: () => import('../views/nivelDeGarantia/NivelBaixoView.vue'),
    },
    {
      path: '/nivel-substancial',
      name: 'nivel-substancial',
      component: () => import('../views/nivelDeGarantia/NivelSubstancialView.vue'),
    },
    {
      path: '/nivel-alto',
      name: 'nivel-alto',
      component: () => import('../views/nivelDeGarantia/NivelAltoView.vue'),
    },

    ...adminRoutes,
  ],
});

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/',
    '/bootstrap',
    '/sem-acesso',
    '/idrc',
    '/idrc-sucesso',
    '/solicitacao',
    '/login',
    '/rc',
    '/redeconsular',
  ];
  const authRequired = !publicPages.includes(to.path);
  const auth = useAuthStore();
  const { logout } = to.query;
  const userSession = Cookies.get('has_user_session')
    ? JSON.parse(atob(Cookies.get('has_user_session'))).message
    : null;

  if (logout) {
    await auth.logoutCallback();
    return '/';
  }

  if (auth.token || authRequired) {
    const authenticated = await auth.verifyLogin();

    if (!authenticated && authRequired) {
      auth.logoutCallback();
      return '/login';
    } else {
      if (to.path === '/login') {
        return '/';
      }
    }
    auth.user = await authService.getSelfData();
  } else { 
    Cookies.remove('has_user_session');
    if (!(userSession === false) && to.path !== '/login') {
      await auth.login('substancial', 'none');
    }
  }
});

export default router;
